module.exports = __webpack_public_path__ + "img/numbered-bullet.e6446e4a.svg";